export const STANDARD_SIGNUP_FORM_ID = "f9b99a24-8b0a-40f1-9711-af266e826255";
export const INVITE_SIGNUP_FORM_ID = "baa424c8-2b79-419c-ab5e-1bbf6e2194b6";
export const EU_STANDARD_SIGNUP_FORM_ID = "0c9f670c-9c62-4b9d-b938-57cf2337aca2";
export const EU_INVITE_SIGNUP_FORM_ID = "88cc2cef-f96d-45cd-bb2f-daf3e0483174";
export const STANDARD_SIGNUP_PRE_EMAIL_CONFIRMATION_FORM_ID =
  "8f6dad93-d5b0-45a0-b53a-6e0727994449";
export const EU_SIGNUP_PRE_EMAIL_CONFIRMATION_FORM_ID = "8ae3e644-e5f5-40b8-895b-6d65ed7b76b4";
